import script from "./Mall.vue?vue&type=script&setup=true&lang=js"
export * from "./Mall.vue?vue&type=script&setup=true&lang=js"

import "./Mall.vue?vue&type=style&index=0&id=7994c85e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7994c85e"]])

export default __exports__